import Vue from 'vue'
import Router from 'vue-router'
import BaseHome from '@/components/app'
import BaseHelp from '@/components/base-help'
import BaseSignUp from '@/components/base-sign-up'
import BaseHomeworkList from '@/components/base-homework-list'
import BaseHomeworkPublish from '@/components/base-homework-publish'
import BaseHomeworkMine from '@/components/base-homework-mine'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'help',
      component: BaseHelp
    },
    {
      path: '/home',
      name: 'home',
      component: BaseHome
    },
    {
      path: '/help',
      name: 'help',
      component: BaseHelp
    },
    {
      path: '/homeworkList',
      name: 'homeworkList',
      component: BaseHomeworkList
    },
    {
      path: '/homeworkPublish',
      name: 'homeworkPublish',
      component: BaseHomeworkPublish
    },
    {
      path: '/homeworkMine',
      name: 'homeworkMine',
      component: BaseHomeworkMine
    },
    {
      path: '/signUp',
      name: 'signUp',
      component: BaseSignUp
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js